var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 6.41667V4.58333C11.0002 3.575 10.1752 2.75 9.16683 2.75H3.66683C2.6585 2.75 1.8335 3.575 1.8335 4.58333V17.4167C1.8335 18.425 2.6585 19.25 3.66683 19.25H18.3335C19.3418 19.25 20.1668 18.425 20.1668 17.4167V8.25C20.1668 7.24167 19.3418 6.41667 18.3335 6.41667H11.0002ZM5.50016 17.4167H3.66683V15.5833H5.50016V17.4167ZM5.50016 13.75H3.66683V11.9167H5.50016V13.75ZM5.50016 10.0833H3.66683V8.25H5.50016V10.0833ZM5.50016 6.41667H3.66683V4.58333H5.50016V6.41667ZM9.16683 17.4167H7.3335V15.5833H9.16683V17.4167ZM9.16683 13.75H7.3335V11.9167H9.16683V13.75ZM9.16683 10.0833H7.3335V8.25H9.16683V10.0833ZM9.16683 6.41667H7.3335V4.58333H9.16683V6.41667ZM17.4168 17.4167H11.0002V15.5833H12.8335V13.75H11.0002V11.9167H12.8335V10.0833H11.0002V8.25H17.4168C17.921 8.25 18.3335 8.6625 18.3335 9.16667V16.5C18.3335 17.0042 17.921 17.4167 17.4168 17.4167ZM16.5002 10.0833H14.6668V11.9167H16.5002V10.0833ZM16.5002 13.75H14.6668V15.5833H16.5002V13.75Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/CompanyIcon.05e86318938271252d0f137c50390b72.svg";
export { ForwardRef as ReactComponent };